import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class TestimonialsComponent extends Component {
  #io = null;
  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) { this.querySelectorAll('.reveal').forEach((e) => e.classList.add('is-visible')); return; }
    this.#io = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) { e.target.classList.add('is-visible'); this.#io?.unobserve(e.target); }
    }, { rootMargin: '0px 0px -10% 0px' });
    this.querySelectorAll('.reveal').forEach((el) => this.#io.observe(el));
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#io?.disconnect(); }
}
if (!customElements.get('testimonials-component')) customElements.define('testimonials-component', TestimonialsComponent);
